import { useEffect, useState, useRef, RefObject, Fragment } from 'react';
import { FaCaretRight } from 'react-icons/fa';
import moment from 'moment';
import querystring from 'querystring';
import { ToastContainer, toast } from 'react-toast';
import Modal from '../../Modal';
import Form from '../../Form';
import {
  InputData,
  initialInputData,
  inputDataConfig,
} from './inputData';
import {
  Wrapper,
  Title,
  ProgressWrapper,
  Progress,
  ProgressArrow,
  Desc,
  FormWrapper,
  Button,
  StatusWrapper,
  StatusBodyWrapper,
  HeaderCell,
  StatusCell,
  CodeWrapper,
  Code,
  CodeTitle,
  CodeDesc,
  CopyButton,
  CodeText
} from "./style"
import {API_URL} from '../../../const'

const Input = () => {
  const params = (new URL(window.location.href)).searchParams;
  const emailEncoded: string|null = params.get("email")
  
  const [buttonActive, setButtonActive] = useState<boolean>(true)
  const [buttonText, setButtonText] = useState<string>("節電達成状況を読み込む")
  const [publishButtonText, setPublishButtonText] = useState<string>("選択したクーポンを発行する")
  const [code, setCode] = useState<string>("")
  const [showCode, setShowCode] = useState<boolean>(false)
  const [historyData, setHistoryData] = useState<Array<any>>([])
  const [isCheckedData, setIsCheckedData] = useState<{[key: string]: boolean}>({})
  const [inputData, setInputData] = useState<InputData>(initialInputData)
  const refs:{[key:string]: RefObject<HTMLDivElement>} = {
    userCode: useRef<HTMLDivElement>(null),
    lastNameKana: useRef<HTMLDivElement>(null),
    firstNameKana: useRef<HTMLDivElement>(null),
  }
  const [errors, setErrors] = useState<{[key: string]: boolean}>({
    userCode: false,
    lastNameKana: false,
    firstNameKana: false,
  })
  const isValid = () => {
    const keys = Object.keys(inputDataConfig)    
    const len = keys.length
    let didScroll = false
    let allMsg = ""
    let newErrors: {[key: string]: boolean} = {}
    for (let i=0;i<len;i++) {
      const key = keys[i]
      const config = inputDataConfig[key]
      newErrors[key] = false
      if (config.required && !inputData[key]) {
        const msg = "・「" + config.name + "」を入力してください。"
        allMsg += msg + "\n"
        if (!didScroll) {
          refs[key].current?.scrollIntoView();
          didScroll = true
        }
        newErrors[key] = true
        continue
      }
      if (config.pattern && !config.pattern.test(inputData[key])) {
        const msg = "・「" + config.name + "」の内容が適切ではありません。もう一度入力内容をご確認ください。"
        allMsg += msg + "\n"
        if (!didScroll) {
          refs[key].current?.scrollIntoView();
          didScroll = true
        }
        newErrors[key] = true
        continue
      }
    }
    setErrors(newErrors)
    if (allMsg) {
      alert("以下の入力項目を修正してください。\n" + allMsg)
      return false
    } else {
      return true
    }
  }

  const isEnablePublish = () => {
    let isEnable = false
    for ( let key in isCheckedData) {
      if (isCheckedData[key]) {
        isEnable = true
        break
      }
    }
    return isEnable
  }

  useEffect(() => {
  }, [])

  const copyToClipboard = async (text: string) => {
    if (!navigator.clipboard) {
      alert("このブラウザはクリップボードコピーに対応していません");
      return;
    }
    try {
      await navigator.clipboard.writeText(text)
      toast("クリップボードにコピーにしました");
    } catch (e) {
      toast("クリップボードコピーに失敗しました");
    }
  }

  const fetchInfo = async () => {
    if (!isValid()) {
      return
    }
    setButtonActive(false);
    setButtonText("節電達成状況読込中...");
    const name = inputData.lastNameKana.replace("）", ")")
    let res: any = await fetch (API_URL + "save-energy/fetch-history?user_code=" + inputData.userCode + "&last_name=" + name, {
      method: 'GET',
      cache: 'no-cache',
      headers: {
        'Content-Type': 'application/json'
      },
    })
    const status = res.status
    setButtonActive(true);
    setButtonText("節電達成状況を読み込む");
    if (status !== 200) {
      const resData = await res.json()
      alert(resData.msg) 
      console.log(resData)
      return
    } 
    res = await res.json()
    res = res["history"]
    console.log("履歴取得レスポンス")
    console.log(JSON.stringify(res))
    // ソート
    const arr = Object.keys(res).map((key) => {
      const item = res[key]
      console.log(item) 
      return {...item, key: key}
    })
    arr.sort((a,b) => {
      a = a.createdAt._seconds
      b = b.createdAt._seconds
      if (a < b) return -1
      else if (a > b) return 1
      else return 0
    })
    setHistoryData(arr)
  }

  return (
    <Wrapper>
      <Title>
        特典クーポン発行ページ
      </Title>
      <Desc>
        特典クーポン発行は2023年9月30日(土)で終了いたしました。たくさんのご利用ありがとうございました。
      </Desc>
      {/*
      <Desc>
        MEMの節電チャレンジに登録されている情報を入力して節電達成状況を読み込んでください。
      </Desc>
      <FormWrapper>
        {Object.keys(inputDataConfig).map((key) => {
          const config = inputDataConfig[key]
          return (
          <Form
            ref={refs[key]}
            title={config.name}
            type={config.type}
            value={inputData[key]}
            caution={config.caution}
            placeholder={config.placeholder}
            required={config.required}
            options={config.options}
            error={errors[key]}
            onChange={(e) => {
              setInputData({...inputData, [key]: e.target.value})
              console.log("save: ")
              console.log(JSON.stringify({...inputData, [key]: e.target.value}))
              localStorage.setItem('inputData', JSON.stringify({...inputData, [key]: e.target.value}))
            }}
          />
          )
        })}
      </FormWrapper>
      <Button 
        disabled={!buttonActive}
        onClick={async () => {
          await fetchInfo()
        }}
      >
        {buttonText}
      </Button>
      <StatusWrapper>
        <StatusBodyWrapper>
          <HeaderCell>
            参加項目
          </HeaderCell>
          <HeaderCell>
            達成状況
          </HeaderCell>
          <HeaderCell>
            発行状況
          </HeaderCell>
          <HeaderCell>
            発行する
          </HeaderCell>
        </StatusBodyWrapper>
        <Fragment>
          {historyData.map((data) => {
            const key = data["key"]
            const isClear = data["isClear"]
            const isClearStr: any = (() => {
              return isClear
                ? "達成済" : "未達成"
            })()
            const isPublished = data["isPublished"]
            const isPublishedStr: any = (() => {
              if (!isClear) return "ー"
              return isPublished ?
                "発行済" : "未発行"
            })()
            return (
              <StatusBodyWrapper>
                <StatusCell>
                  {key} 
                </StatusCell>
                <StatusCell>
                  {isClearStr} 
                </StatusCell>
                <StatusCell>
                  {isPublishedStr} 
                </StatusCell>
                <StatusCell>
                  {(isClear && !isPublished) && (
                    <input
                      type="checkbox"
                      id="check"
                      checked={isCheckedData[key]}
                      onChange={() => setIsCheckedData({...isCheckedData, [key]: !isCheckedData[key]})}
                    />
                  )}
                </StatusCell>
              </StatusBodyWrapper>
            )
          })}
        </Fragment>
      </StatusWrapper>
      <Button onClick={async () => {
          if (!window.confirm("選択した内容でクーポンコードを発行してよろしいですか？")) return
          let types:any = []
          Object.keys(isCheckedData).map((key: string) => {
            if (!isCheckedData[key]) return
            types.push(key)
          })
          types = {
            types: types
          }
          const typesQuery = querystring.stringify(types)
          const url = API_URL + "save-energy/publish-code?user_code=" + inputData.userCode + "&" + typesQuery
          setPublishButtonText("クーポンコード発行中...")
          const res = await fetch (url, {
            method: 'GET',
            cache: 'no-cache',
            headers: {
              'Content-Type': 'application/json'
            },
          })
          setPublishButtonText("選択したクーポンを発行する")
          const status = res.status
          if (status !== 200) {
            const resData = await res.json()
            alert(resData.msg) 
            console.log(resData)
            return
          } 
          const resData = await res.json()
          setCode(resData.code)
          setShowCode(true);
          setIsCheckedData({});
          await fetchInfo()
        }}
        disabled={!isEnablePublish() || publishButtonText === "クーポンコード発行中..."}
      >
        {publishButtonText}
      </Button>
      <a href="https://m-em.co.jp/about_coupon" target="_blank" rel="noopener noreferrer">クーポンのご利用方法はこちら</a>
      {/*<p>※クーポンの発行はまとめて発行できます。発行後に未発行クーポンとまとめることはできません。</p>
      <p>※各クーポンの発行は一度限りです。</p>
      <p>
        ＜有効期限＞<br/>
        □ 参加申請特典 ▷ 2月上旬付与　有効期限：2023年7月31日23:59迄<br/>
        □ 1月節電達成特典 ▷ 2月上旬付与　有効期限：2023年7月31日23:59迄<br/>
        □ 2月節電達成特典 ▷ 2月下旬〜3月上旬付与　有効期限：2023年8月31日23:59迄<br/>
        □ 3月節電達成特典 ▷ 3月下旬付与　有効期限：2023年9月30日23:59迄<br/>
      </p>
      <p>
        ＜注意事項＞<br/>

        ※ご利用方法については専用ページに記載しております。手順に沿ってお手続きをお願い致します。<br/>
        ※各クーポンの発行は一度限りです。<br/>
        ※クーポンの発行はまとめて発行できます。発行後に未発行クーポンとまとめることはできません。<br/>
        ※クーポンの発行は、一度発行すると変更や取り消しは出来ませんのでご注意ください。<br/>
        ※複数クーポンを合算された場合は、最長期限クーポンの有効期限となります。<br/>
        ※期限を過ぎますと無効となりますのでご注意ください。<br/>
      </p>
      <Modal
        active={showCode}
        onClose={() => {
          setShowCode(false)
        }}
      >
        <CodeWrapper>
          <CodeTitle>以下のクーポンコードを発行しました。</CodeTitle>
          <Code>
            <CodeText>
              {code}
            </CodeText>
            <CopyButton
              onClick={() => {
                copyToClipboard(code)
              }}
            />
          </Code>
          <CodeDesc>※このコードはお客様のメールアドレスへメールにてお送りしております。</CodeDesc>
        </CodeWrapper>
      </Modal>
      <ToastContainer position={"top-center"} delay={3000}/>
      */}
    </Wrapper>
  )
}
export default Input;
